import React, { useLayoutEffect, useState } from 'react'
import Hero from './Hero';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import AuthenticationService from '../../../Authentication/AuthenticationService';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  useLayoutEffect(() => {
    console.log(window)
    AuthenticationService.GetClientDetailsByPrefix(window.location.hostname.split(".")[0]).then((res=>{
      if(res.data){
       navigate('/login')
      }
    })).catch(()=>{setLoading(false)})
  }, [])
  
  return (
    !loading &&
    <>
      <Header />
      <Hero />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Footer />  
    </>
  )
}

export default Home